/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { ActionType } from 'cio/models/action';
import Component from '@glimmer/component';
import DeviceModel from 'cio/models/device';

interface DeviceRowSummaryArgs {
  device: DeviceModel;
  index: number;
}

export default class DeviceRowSummary extends Component<DeviceRowSummaryArgs> {
  get actionType(): ActionType {
    return 'push_action';
  }
}
